// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WifiTopologyDoc.css — Panel del borrador de documentación del WiFi.
 * Reutiliza las clases \`wtopo-*\` del panel lateral de la topología.
 */

.wtopo-doc { width: 560px; }
/* La columna flex necesita altura completa para que el borrador haga scroll
   dentro del panel en vez de estirar la página */
.wtopo-doc .wtopo-inner { height: 100%; }

.wtopo-error {
  padding: 8px 11px; border-radius: 8px; font-size: 12.5px;
  background: rgba(220, 38, 38, .12); border: 1px solid rgba(220, 38, 38, .4); color: #dc2626;
}

/* Borrador en texto plano: monospace y con saltos respetados para poder
   copiarlo tal cual o compararlo con lo que se guarde en el documento. */
.wtopo-doc-pre {
  flex: 1 1;
  margin: 0;
  padding: 14px 16px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--text-secondary);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
  overflow: auto;
  max-height: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/WifiTopologyDoc.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,aAAa,YAAY,EAAE;AAC3B;iDACiD;AACjD,0BAA0B,YAAY,EAAE;;AAExC;EACE,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB;EACxD,kCAAkC,EAAE,uCAAuC,EAAE,cAAc;AAC7F;;AAEA;yEACyE;AACzE;EACE,SAAO;EACP,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,qEAAqE;EACrE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/**\r\n * WifiTopologyDoc.css — Panel del borrador de documentación del WiFi.\r\n * Reutiliza las clases `wtopo-*` del panel lateral de la topología.\r\n */\r\n\r\n.wtopo-doc { width: 560px; }\r\n/* La columna flex necesita altura completa para que el borrador haga scroll\r\n   dentro del panel en vez de estirar la página */\r\n.wtopo-doc .wtopo-inner { height: 100%; }\r\n\r\n.wtopo-error {\r\n  padding: 8px 11px; border-radius: 8px; font-size: 12.5px;\r\n  background: rgba(220, 38, 38, .12); border: 1px solid rgba(220, 38, 38, .4); color: #dc2626;\r\n}\r\n\r\n/* Borrador en texto plano: monospace y con saltos respetados para poder\r\n   copiarlo tal cual o compararlo con lo que se guarde en el documento. */\r\n.wtopo-doc-pre {\r\n  flex: 1;\r\n  margin: 0;\r\n  padding: 14px 16px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  color: var(--text-secondary);\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\r\n  font-size: 12px;\r\n  line-height: 1.55;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n  overflow: auto;\r\n  max-height: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
